import { createAnalyticsChannel } from '@muse/analytics'

export type TRequestParams = {
  requestId?: number
}

export const enum TRequestEventName {
  Open = 'open',
  Review = 'submit_review',
  Share = 'share',
}

type TRequestEventOpen = {
  event: TRequestEventName.Open
  requestId: number
}

type TRequestEventReview = {
  event: TRequestEventName.Review
  requestId: number
}

type TRequestEventShare = {
  event: TRequestEventName.Share
  requestId: number
}

export type TRequestEvent = TRequestEventReview | TRequestEventOpen | TRequestEventShare

export const requestChannel = createAnalyticsChannel<TRequestEvent, TRequestParams>('request')
